import * as Constants from './constants'

export const readyForRender = () => ({type: Constants.READY_FOR_RENDER})
